<style lang="less" scoped>

</style>
<template>
  <VTableCard 
    :value="value"
    :sub-title="value.name"
    :fields="tableCardFields"
    :md="6"
  >
    <template v-slot:card_title="{ value }">
      <p>
        {{ value.uid }}<span
          v-show="value.del"
          style="margin-left:10px;font-weight:normal"
          class="color-error"
        >[已废弃]</span>
      </p>
    </template>
    <template v-slot:footer="{ }">
      <v-card-actions>
        <v-btn
          icon
          @click="toggleExpand"
        >
          <v-icon>{{ expand ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        <v-spacer />
        <div v-if="showAction&&!value.del">
          <v-btn
            color="primary"
            text
            @click="del(value)"
          >
            <v-icon>mdi-close-circle-outline</v-icon>
            废弃
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="edit"
          >
            <v-icon>mdi-pencil-outline</v-icon>
            修改
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="copy"
          >
            <v-icon>mdi-content-copy</v-icon>
            复制
          </v-btn>
        </div>
      </v-card-actions>
      <v-expand-transition>
        <div 
          v-if="expand"
          style="position:relative"
        >
          <v-divider />
          <VOverlayLoading
            :value="item_loading"
          />

          <v-card-text>
            <VTableCard 
              v-for="(item,index) in child_items"
              :key="index"
              :style="{
                'margin-bottom':'10px'
              }"
              :value="item"
              :fields="childFields"
              :md="6"
            >
              <template v-slot:account_title_id="{value}">
                <v-ripple-col
                  md="6"
                  cols="12"
                >
                  <span style="white-space:nowrap">会计科目：</span>
                  <v-spacer />
                  <AccountTitle :id="value.account_title_id" />
                </v-ripple-col>
              </template>
              <template v-slot:analysis_title_id="{value}">
                <v-ripple-col
                  md="6"
                  cols="12"
                >
                  <span style="white-space:nowrap">分析科目：</span>
                  <v-spacer />
                  <AnalysisTitle :id="value.analysis_title_id" />
                </v-ripple-col> 
              </template>
            </VTableCard>
          </v-card-text>
        </div>
      </v-expand-transition>
    </template>
  </VTableCard>
</template>
<script>
  import { mapGetters } from 'vuex'
  import VTableCard from '@/vuetify_custom/v-table-card'
  import VOverlayLoading from '@/vuetify_custom/v-overlay-loading';
  import { util_api } from '@/libs/util_api'
  import InvoiceUtil from '@/views/invoice/libs/util';
  import receipt_card_mixins from '../mixins/receipt_card_mixins'
  import receipt_base from '../mixins/receipt_base'
  import AccountTitle from './account_title';
  import AnalysisTitle from './analysis_title';
  import VRippleCol from '../../../vuetify_custom/v-ripple-col';
  import { unit_types } from '../fields'
  const { fin_receipt_accrual_bill_items } = util_api
  export default {
    components: {
      'v-ripple-col': VRippleCol,
      VTableCard,
      VOverlayLoading,
      AccountTitle,
      AnalysisTitle
    },
    mixins:[receipt_base, receipt_card_mixins],
    props: {
      value: {
        type: Object
      },
      showAction: {
        type: Boolean,
        default: true
      }
    },
    data() {
      this.get_items_api = fin_receipt_accrual_bill_items
      return {
      }
    },
    computed: {
      ...mapGetters('async', ['receipt_bill_types', 'clients', 'receipt_purposes']),
      tableCardFields() {
        return [
          {
            label: '单据类型：',
            key: 'bill_type',
            type: 'select_field',
            items: this.receipt_bill_types.concat({
              uid: 'other',
              name: '其他'
            }),
            text_key: 'name',
            value_key: 'uid'
          },
          {
            label: '收款用途编号：',
            key: 'purpose_uid',
            type: 'select_field',
            text_key: 'name',
            value_key: 'kingdee_uid',
            items: this.receipt_purposes,
          },
          {
            label: '公司：',
            key: 'company_id',
            type: 'company_field'
          },
          {
            label: '项目组：',
            key: 'team_id',
            type: 'team_field'
          },
          {
            label: '往来单位类型：',
            key: 'contact_unit_type',
            type: 'select_field',
            items: unit_types,
            text_key: 'name',
            value_key: 'uid'
          },
          {
            label: '来往单位：',
            key: 'contact_unit_name',
            type: 'text_field',
            // ...this.contactUnit
          },
          {
            label: '业务日期：',
            key: 'handled_at',
            type: 'date_field'
          },
          {
            label: '计提金额：',
            key: 'total_amount',
            type: 'money_field',
            value_key: 'id',
            currency_type_key: 'currency',
          },
          {
            label: '状态：',
            key: 'user_flow',
            flow_title: 'name',
            type: 'user_flow_base',
          },
          {
            label: '备注：',
            key: 'remark',
            type: 'text_field',
            cols:12,
            md: 12
          }
        ]
      },
      childFields() {
        return [
          {
            label: '单据名称：',
            key: 'name',
            type: 'text_field',
          },
          {
            label: '团队：',
            key: 'team_id',
            type: 'team_field'
          },
          {
            label: '会计科目：',
            key: 'account_title_id',
          },
          {
            label: '分析科目：',
            key: 'analysis_title_id',
          },
          {
            label: '计提总金额：',
            key: 'total_amount',
            type: 'money_field',
          },
          {
            label: '人民币总金额金额：',
            key: 'cny_total_amount',
            type: 'money_field',
          },
          {
            label: '税率：',
            key: 'tax_rate',
          },
          {
            label: '税额：',
            key: 'tax',
            type: 'money_field',
          },
          {
            label: '发票类型：',
            key: 'invoice_type',
            type: 'select_field',
            items: InvoiceUtil.invoice_types,
            text_key: 'name',
            value_key: 'value'
          },
          {
            label: '备注：',
            key: 'remark',
            type: 'text_field',
            cols:12,
            md: 12
          }
        ]
      },
    },
    methods: {

    }
  }
</script>

